var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 153,
    viewBox: "0 0 136 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1066 2.14282C73.6036 2.14282 78.047 6.58619 78.047 12.0833V22.3694C78.047 23.4672 78.9542 24.375 80.0519 24.3752C81.1498 24.3752 82.0577 23.4673 82.0577 22.3694C82.058 16.8725 86.5012 12.429 91.9982 12.429C97.495 12.429 101.938 16.8726 101.939 22.3694V73.844C101.939 74.521 102.272 75.1525 102.865 75.5549L102.876 75.5627C103.124 75.7333 103.471 75.8488 103.943 75.8489C104.231 75.8489 104.532 75.7845 104.778 75.6819C107.59 74.445 110.734 73.8167 113.94 73.8167C118.995 73.8167 123.877 75.3048 127.753 78.0735L130.969 80.3704L127.289 81.8118C124.531 82.8927 121.63 84.7575 119.526 88.094C117.439 91.4106 114.709 97.9281 112.292 104.283C109.926 110.505 107.942 116.347 107.284 118.337C107.253 118.462 107.222 118.588 107.191 118.713C103.56 137.236 87.0944 150.647 68.1896 150.647C49.3621 150.647 32.9013 137.315 29.0636 118.883C29.0588 118.863 29.0547 118.844 29.0509 118.828C29.0447 118.802 29.0411 118.786 29.0363 118.766C29.0325 118.75 29.0281 118.738 29.0255 118.728L28.9991 118.674L28.9513 118.53C28.5404 117.297 26.57 111.437 24.132 104.984C21.6659 98.4562 18.8125 91.5719 16.6456 88.136L16.6447 88.135C14.5375 84.7927 11.6755 82.9331 8.89172 81.8567L5.16125 80.4143L8.42883 78.1077C12.3363 75.3495 17.1696 73.8587 22.2316 73.8586C25.2478 73.8586 28.251 74.4145 30.9435 75.5149L31.4777 75.7424L31.5089 75.7561C31.7838 75.8829 32.0178 75.9319 32.2697 75.9319C32.5938 75.9319 32.9863 75.8303 33.4005 75.5989C33.9599 75.1954 34.2745 74.5833 34.2745 73.927V22.4114C34.2745 16.9144 38.7181 12.4712 44.215 12.4709C49.712 12.4709 54.1554 16.9143 54.1554 22.4114C54.1554 23.5093 55.0633 24.4163 56.1613 24.4163C57.2591 24.4161 58.1661 23.5092 58.1661 22.4114V12.0833C58.1661 6.58623 62.6096 2.14288 68.1066 2.14282Z",
    fill: "#0072A3",
    stroke: "#003B75",
    strokeWidth: 4.2853
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2469 15.55C72.9239 15.5502 76.6814 19.3523 76.6815 24.0256V32.3801C76.6815 33.0629 77.2415 33.6067 77.8856 33.6067C78.5295 33.6065 79.0897 33.0627 79.0897 32.3801C79.0899 27.7068 82.8464 23.9048 87.5233 23.9045C92.2004 23.9045 95.9577 27.7067 95.9579 32.3801V74.1868C95.9579 74.5528 96.1136 74.8977 96.3993 75.1467L96.5302 75.2473L96.5409 75.2542C96.6603 75.3368 96.8525 75.4123 97.162 75.4124C97.3352 75.4124 97.5226 75.3723 97.6718 75.3098C99.9958 74.282 102.589 73.762 105.227 73.762C109.389 73.762 113.415 74.9947 116.619 77.2981L119.807 79.5901L116.154 81.0305C113.991 81.8838 111.729 83.3482 110.089 85.967L110.09 85.968C108.43 88.6223 106.24 93.8789 104.287 99.0471C102.386 104.08 100.79 108.807 100.257 110.432C100.234 110.525 100.211 110.618 100.187 110.711C97.2191 125.934 83.7704 136.967 68.3134 136.967C52.9187 136.967 39.4767 125.998 36.3407 110.852C36.3373 110.838 36.3336 110.825 36.3309 110.814C36.3298 110.809 36.3291 110.804 36.328 110.799C36.3269 110.795 36.3251 110.791 36.3241 110.786C36.3231 110.782 36.322 110.778 36.3212 110.775L36.3075 110.746L36.2596 110.603C35.9289 109.604 34.3404 104.85 32.3759 99.6155C30.5079 94.6386 28.3789 89.4469 26.7001 86.551L26.371 86.0032C24.7264 83.3774 22.4954 81.9165 20.3143 81.0676L16.6112 79.6262L19.8505 77.3245C23.0775 75.0316 27.0641 73.7961 31.2323 73.7961C33.7171 73.7962 36.1955 74.2568 38.4227 75.1731L38.8641 75.3625L38.8954 75.3762C39.0654 75.4552 39.1934 75.4797 39.3309 75.4797C39.5037 75.4797 39.7428 75.4235 40.0184 75.2717C40.3511 75.0198 40.535 74.6506 40.535 74.2542V32.4143C40.535 27.7408 44.2925 23.9378 48.9696 23.9377C53.6468 23.9377 57.4042 27.7407 57.4042 32.4143C57.4043 33.0969 57.9643 33.6399 58.6083 33.6399C59.2523 33.6399 59.8123 33.0969 59.8124 32.4143V24.0256C59.8125 19.3522 63.5699 15.55 68.2469 15.55Z",
    fill: "#149E99",
    stroke: "#003B75",
    strokeWidth: 4.2853
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8331 73.9446C71.7217 72.7845 78.1497 74.4175 83.2316 77.095C88.3338 79.7833 92.1107 83.5429 94.6193 86.6536C95.8706 88.2052 96.7976 89.5853 97.4093 90.5715C97.5036 90.7237 97.5889 90.8679 97.6681 91.0002C76.2199 105.532 60.8384 104.163 50.8624 99.4163C45.7293 96.974 41.925 93.5906 39.4005 90.8069C38.1401 89.4171 37.2052 88.1834 36.589 87.304C36.5154 87.1989 36.4484 87.0977 36.3839 87.0032C47.0518 78.8405 56.1775 75.0705 63.8331 73.9446Z",
    fill: "#003B75",
    stroke: "#F1ECE2",
    strokeWidth: 2.94562
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.237 85.621C77.2572 79.4087 71.1336 75.1234 64.9213 76.1032C58.709 77.0829 54.4237 83.2067 55.4035 89.419C56.3832 95.6313 62.507 99.9165 68.7193 98.9367C74.9316 97.957 79.2168 91.8333 78.237 85.621Z",
    fill: "#003B75",
    stroke: "#F1ECE2",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2322 101.38L57.1876 93.8629",
    stroke: "#003B75",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2107 65.3545L75.3303 75.0991",
    stroke: "#003B75",
    strokeWidth: 2.371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.079 98.9524L63.0514 108.987",
    stroke: "#003B75",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9062 74.671L69.3866 63.1376",
    stroke: "#003B75",
    strokeWidth: 2.371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5522 107.914L73.1638 97.1528",
    stroke: "#003B75",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8123 63.086L59.0511 74.3962",
    stroke: "#003B75",
    strokeWidth: 2.371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2226 100.134L77.8399 90.8032",
    stroke: "#003B75",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6474 67.1868L55.1313 75.0605",
    stroke: "#003B75",
    strokeWidth: 2.37099,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3652 87.0947L78.4407 87.3281",
    stroke: "#F1ECE2",
    strokeWidth: 3.83136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.cf0b59a0ad0dae7e3d3776e979361e8a.svg";
export { ForwardRef as ReactComponent };